/* Adapted from the supplied page blog/script.js reveal:
   start: top bottom; end: bottom bottom; y: -35 * (1 - progress).
   Scoped native scrolling preserves the theme's navigation and touch behavior. */
(() => {
  if (customElements.get('cm-journal')) return;
  class CMJournal extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { passive: true, signal: this.controller.signal };
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.enabled = this.dataset.motion !== 'false';
      this.querySelectorAll('.cm-journal__body img').forEach(img => {
        if (img.closest('[data-journal-reveal]')) return;
        const frame = document.createElement('div');
        frame.className = 'cm-journal__inline-media';
        frame.dataset.journalReveal = '';
        const moving = document.createElement('div');
        moving.className = 'cm-journal__moving';
        img.parentNode.insertBefore(frame, img);
        moving.append(img);
        frame.append(moving);
        img.loading = 'lazy';
      });
      this.frames = [...this.querySelectorAll('[data-journal-reveal]')];
      // The supplied demo reveals the whole footer, not only photographs.
      // Keep its clipping frame stationary while the existing footer moves inside.
      this.footer = this.closest('.page-wrapper')?.querySelector(':scope > footer');
      if (this.footer && !this.footer.querySelector(':scope > .cm-journal-footer__inner')) {
        this.footerInner = document.createElement('div');
        this.footerInner.className = 'cm-journal-footer__inner';
        this.footerInner.append(...this.footer.childNodes);
        this.footer.append(this.footerInner);
        this.footer.classList.add('cm-journal-footer');
        this.frames.push(this.footer);
      }
      this.requestTick = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.update();
        });
      };
      // Capture scrolling from the theme's page-wrapper as well as the document.
      document.addEventListener('scroll', this.requestTick, { ...options, capture: true });
      window.addEventListener('resize', this.requestTick, options);
      this.motion.addEventListener('change', this.requestTick, { signal: this.controller.signal });
      this.resizeObserver = new ResizeObserver(this.requestTick);
      this.resizeObserver.observe(this);
      if (this.footerInner) this.resizeObserver.observe(this.footer);
      this.update();
    }
    update() {
      const animate = this.enabled && !this.motion.matches;
      this.classList.toggle('cm-journal--motion', animate);
      if (this.footerInner) this.footer.classList.toggle('cm-journal-footer--motion', animate);
      const viewport = window.innerHeight;
      for (const panel of this.frames) {
        const rect = panel.getBoundingClientRect();
        const progress = Math.max(0, Math.min(1, (viewport - rect.top) / Math.max(rect.height, 1)));
        panel.style.setProperty('--journal-y', animate ? `${-35 * (1 - progress)}%` : '0%');
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      if (this.footerInner) {
        this.footerInner.replaceWith(...this.footerInner.childNodes);
        this.footer.classList.remove('cm-journal-footer', 'cm-journal-footer--motion');
        this.footer.style.removeProperty('--journal-y');
        this.footerInner = null;
      }
    }
  }
  customElements.define('cm-journal', CMJournal);
})();
